import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Space, Typography, Tag, message } from 'antd';
import {
  DashboardOutlined, UserOutlined, TeamOutlined, MessageOutlined,
  AppstoreOutlined, SettingOutlined, PictureOutlined, CameraOutlined,
  LogoutOutlined, ApiOutlined, SafetyOutlined, AuditOutlined,
  WarningOutlined, HddOutlined, UserSwitchOutlined,
  PictureTwoTone, NotificationOutlined, UnorderedListOutlined,
  FileTextOutlined, TagsOutlined, StopOutlined, MailOutlined,
  SafetyCertificateOutlined, PhoneOutlined, VideoCameraOutlined, SmileOutlined,
} from '@ant-design/icons';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import api from './api';

// 页面组件
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UserManagePage from './pages/UserManagePage';
import UserDetailPage from './pages/UserDetailPage';
import UserTagsPage from './pages/UserTagsPage';
import UserBlacklistPage from './pages/UserBlacklistPage';
import GroupManagePage from './pages/GroupManagePage';
import ConfigPage from './pages/ConfigPage';
import MiniProgramPage from './pages/MiniProgramPage';
import MiniProgramDetailPage from './pages/MiniProgramDetailPage';
import MiniProgramCategoryPage from './pages/MiniProgramCategoryPage';
import PluginManagePage from './pages/PluginManagePage';
import TabConfigPage from './pages/TabConfigPage';
import OperationConfigPage from './pages/OperationConfigPage';
import MessageManagePage from './pages/MessageManagePage';
import MomentManagePage from './pages/MomentManagePage';
import MaterialPage from './pages/MaterialPage';
import BannerPage from './pages/BannerPage';
import AnnouncementPage from './pages/AnnouncementPage';
import AdminUserManagePage from './pages/AdminUserManagePage';
import AuditLogPage from './pages/AuditLogPage';
import AuditWorkbenchPage from './pages/AuditWorkbenchPage';
import SensitiveWordPage from './pages/SensitiveWordPage';
import SystemMonitorPage from './pages/SystemMonitorPage';
import MiniProgramDeveloperPage from './pages/MiniProgramDeveloperPage';
import MiniProgramReviewPage from './pages/MiniProgramReviewPage';
import EmailConfigPage from './pages/EmailConfigPage';
import CaptchaManagePage from './pages/CaptchaManagePage';
import CallsPage from './pages/CallsPage';
import StickerManagePage from './pages/StickerManagePage';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

// 菜单项
const menuItems = [
  { key: 'dashboard', icon: <DashboardOutlined />, label: '仪表盘', path: '/dashboard' },
  {
    key: 'user-manage', icon: <UserOutlined />, label: '用户管理',
    children: [
      { key: 'users', icon: <UserOutlined />, label: '用户列表', path: '/users' },
      { key: 'user-blacklist', icon: <StopOutlined />, label: '黑名单', path: '/user-blacklist' },
      { key: 'user-tags', icon: <TagsOutlined />, label: '用户标签', path: '/user-tags' },
      { key: 'groups', icon: <TeamOutlined />, label: '群组管理', path: '/groups' },
    ],
  },
  {
    key: 'mini-program', icon: <AppstoreOutlined />, label: '小程序管理',
    children: [
      { key: 'mini-programs', icon: <AppstoreOutlined />, label: '小程序列表', path: '/mini-programs' },
      { key: 'mini-program-categories', icon: <UnorderedListOutlined />, label: '分类管理', path: '/mini-program-categories' },
      { key: 'mini-program-developer', icon: <AppstoreOutlined />, label: '开发者后台', path: '/mini-developer' },
      { key: 'mini-program-review', icon: <AuditOutlined />, label: '审核管理', path: '/mini-review' },
    ],
  },
  {
    key: 'content-manage', icon: <PictureOutlined />, label: '内容管理',
    children: [
      { key: 'messages', icon: <MessageOutlined />, label: '消息管理', path: '/messages' },
      { key: 'moments', icon: <CameraOutlined />, label: '朋友圈管理', path: '/moments' },
      { key: 'materials', icon: <PictureTwoTone />, label: '素材管理', path: '/materials' },
      { key: 'stickers', icon: <SmileOutlined />, label: '表情管理', path: '/stickers' },
    ],
  },
  {
    key: 'operations', icon: <SafetyOutlined />, label: '运营配置',
    children: [
      { key: 'banners', icon: <PictureOutlined />, label: '轮播图管理', path: '/banners' },
      { key: 'announcements', icon: <NotificationOutlined />, label: '公告管理', path: '/announcements' },
      { key: 'operation-config', icon: <SafetyOutlined />, label: '运营设置', path: '/operation-config' },
    ],
  },
  {
    key: 'plugin-manage', icon: <ApiOutlined />, label: '插件管理',
    children: [
      { key: 'plugins', icon: <ApiOutlined />, label: '插件列表', path: '/plugins' },
      { key: 'tab-config', icon: <SettingOutlined />, label: 'Tab 配置', path: '/tab-config' },
    ],
  },
  { key: 'config', icon: <SettingOutlined />, label: '应用配置', path: '/config' },
  {
    key: 'system', icon: <HddOutlined />, label: '系统管理',
    children: [
      { key: 'system-monitor', icon: <HddOutlined />, label: '系统监控', path: '/system-monitor' },
      { key: 'admin-users', icon: <UserSwitchOutlined />, label: '管理员管理', path: '/admin-users' },
      { key: 'audit-logs', icon: <AuditOutlined />, label: '审计日志', path: '/audit-logs' },
      { key: 'sensitive-words', icon: <WarningOutlined />, label: '敏感词管理', path: '/sensitive-words' },
      { key: 'captcha-manage', icon: <SafetyCertificateOutlined />, label: '图形验证码', path: '/captcha-manage' },
      { key: 'audit-workbench', icon: <AuditOutlined />, label: '审计工作台', path: '/audit-workbench' },
    ],
  },
  {
    key: 'call-manage', icon: <PhoneOutlined />, label: '通话管理',
    children: [
      { key: 'call-voice', label: '语音通话', path: '/call-voice' },
      { key: 'call-video', label: '视频通话', path: '/call-video' },
      { key: 'call-group-voice', label: '群语音通话', path: '/call-group-voice' },
      { key: 'call-group-video', label: '群视频通话', path: '/call-group-video' },
    ],
  },
  { key: 'email-config', icon: <MailOutlined />, label: '邮件配置', path: '/email-config' },
];

const roleMap = {
  super_admin: { label: '超级管理员', color: '#f5222d' },
  admin: { label: '管理员', color: '#1890ff' },
  operator: { label: '运营人员', color: '#52c41a' },
  auditor: { label: '审计员', color: '#fa8c16' },
};

// 内部组件 - 使用路由
const AppContent = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [current, setCurrent] = useState('dashboard');

  useEffect(() => {
    const handler = (e) => {
      setCurrent(e.detail);
      const findPath = (items) => {
        for (const item of items) {
          if (item.key === e.detail) return item.path;
          if (item.children) {
            const childPath = findPath(item.children);
            if (childPath) return childPath;
          }
        }
        return null;
      };
      const path = findPath(menuItems);
      if (path) navigate(path);
    };
    window.addEventListener('navigate', handler);
    return () => window.removeEventListener('navigate', handler);
  }, [navigate]);

  const handleLogout = () => {
    delete api.defaults.headers.common['Authorization'];
    localStorage.removeItem('admin_token');
    setUser(null);
  };

  const handleMenuClick = ({ key }) => {
    setCurrent(key);
    const findPath = (items) => {
      for (const item of items) {
        if (item.key === key) return item.path;
        if (item.children) {
          const childPath = findPath(item.children);
          if (childPath) return childPath;
        }
      }
      return null;
    };
    const path = findPath(menuItems);
    if (path) navigate(path);
  };

  const renderPage = () => {
    switch (current) {
      case 'dashboard': return <DashboardPage />;
      case 'users': return <UserManagePage />;
      case 'user-tags': return <UserTagsPage />;
      case 'user-blacklist': return <UserBlacklistPage />;
      case 'groups': return <GroupManagePage />;
      case 'messages': return <MessageManagePage />;
      case 'moments': return <MomentManagePage />;
      case 'materials': return <MaterialPage />;
      case 'stickers': return <StickerManagePage />;
      case 'banners': return <BannerPage />;
      case 'announcements': return <AnnouncementPage />;
      case 'plugins': return <PluginManagePage />;
      case 'tab-config': return <TabConfigPage />;
      case 'mini-programs': return <MiniProgramPage />;
      case 'mini-program-categories': return <MiniProgramCategoryPage />;
      case 'operation-config': return <OperationConfigPage />;
      case 'config': return <ConfigPage />;
      case 'system-monitor': return <SystemMonitorPage />;
      case 'admin-users': return <AdminUserManagePage />;
      case 'audit-logs': return <AuditLogPage />;
      case 'sensitive-words': return <SensitiveWordPage />;
      case 'mini-program-developer': return <MiniProgramDeveloperPage />;
      case 'mini-program-review': return <MiniProgramReviewPage />;
      case 'email-config': return <EmailConfigPage />;
      case 'captcha-manage': return <CaptchaManagePage />;
      case 'audit-workbench': return <AuditWorkbenchPage />;
      case 'call-voice': return <CallsPage scope="p2p" type="audio" />;
      case 'call-video': return <CallsPage scope="p2p" type="video" />;
      case 'call-group-voice': return <CallsPage scope="group" type="audio" />;
      case 'call-group-video': return <CallsPage scope="group" type="video" />;
      default: return <DashboardPage />;
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} theme="dark" width={220}>
        <div style={{ padding: '16px 0', textAlign: 'center' }}>
          <Text style={{ color: '#fff', fontSize: 18, fontWeight: 'bold' }}>{collapsed ? 'YX' : '云信管理后台'}</Text>
        </div>
        <Menu theme="dark" mode="inline" selectedKeys={[current]} onClick={handleMenuClick} items={menuItems} />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div></div>
          <Space>
            {user.role && (
              <Tag color={roleMap[user.role]?.color || '#666'}>{roleMap[user.role]?.label || user.role}</Tag>
            )}
            <Avatar style={{ background: '#07C160' }} icon={<UserOutlined />} />
            <Text>{user.nickname || '管理员'}</Text>
            <a onClick={handleLogout} style={{ color: '#ff4d4f' }}>
              <LogoutOutlined /> 退出
            </a>
          </Space>
        </Header>
        <Content style={{ margin: 24, padding: 24, background: '#f5f7fa', minHeight: 'calc(100vh - 112px)', overflow: 'auto' }}>
          <Routes>
            <Route path="/" element={renderPage()} />
            <Route path="/users" element={<UserManagePage />} />
            <Route path="/user-detail/:id" element={<UserDetailPage />} />
            <Route path="/user-blacklist" element={<UserBlacklistPage />} />
            <Route path="/groups" element={<GroupManagePage />} />
            <Route path="/messages" element={<MessageManagePage />} />
            <Route path="/moments" element={<MomentManagePage />} />
            <Route path="/materials" element={<MaterialPage />} />
            <Route path="/stickers" element={<StickerManagePage />} />
            <Route path="/banners" element={<BannerPage />} />
            <Route path="/announcements" element={<AnnouncementPage />} />
            <Route path="/plugins" element={<PluginManagePage />} />
            <Route path="/tab-config" element={<TabConfigPage />} />
            <Route path="/mini-programs" element={<MiniProgramPage />} />
            <Route path="/mini-programs/:id" element={<MiniProgramDetailPage />} />
            <Route path="/mini-program-categories" element={<MiniProgramCategoryPage />} />
            <Route path="/mini-developer" element={<MiniProgramDeveloperPage />} />
            <Route path="/mini-review" element={<MiniProgramReviewPage />} />
            <Route path="/operation-config" element={<OperationConfigPage />} />
            <Route path="/config" element={<ConfigPage />} />
            <Route path="/system-monitor" element={<SystemMonitorPage />} />
            <Route path="/admin-users" element={<AdminUserManagePage />} />
            <Route path="/audit-logs" element={<AuditLogPage />} />
            <Route path="/sensitive-words" element={<SensitiveWordPage />} />
            <Route path="/email-config" element={<EmailConfigPage />} />
            <Route path="/captcha-manage" element={<CaptchaManagePage />} />
          <Route path="/audit-workbench" element={<AuditWorkbenchPage />} />
          <Route path="/call-voice" element={<CallsPage scope="p2p" type="audio" />} />
          <Route path="/call-video" element={<CallsPage scope="p2p" type="video" />} />
          <Route path="/call-group-voice" element={<CallsPage scope="group" type="audio" />} />
          <Route path="/call-group-video" element={<CallsPage scope="group" type="video" />} />
          <Route path="*" element={renderPage()} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      api.get('/auth/me').then(setUser).catch(() => {
        localStorage.removeItem('admin_token');
        setUser(null);
      });
    }
  }, []);

  if (!user) {
    return <LoginPage onLogin={(u) => setUser(u)} />;
  }

  return (
    <BrowserRouter basename="/admin">
      <AppContent user={user} setUser={setUser} />
    </BrowserRouter>
  );
};

export default App;
